module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "half"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('big', [_vm._v("R")]), _vm._v("ACHMANINOFF"), _c('big', [_vm._v("’")]), _vm._v("S "), _c('big', [_vm._v("C")]), _vm._v("OMPLETE "), _c('big', [_vm._v("S")]), _vm._v("ONGS")], 1)])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f76b16e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/011_half1.vue
// module id = 87
// module chunks = 0